import isEmpty from "lodash/isEmpty";

export const convertRange = (range) => {
  if (isEmpty(range)) return {};

  const [from, to] = range;

  return { from: from.unix(), to: to.unix() };
};
